import React from 'react';
import './TeacherAnalytics.css';
import TeacherStatsComponent from '../TeacherStatsComponent/TeacherStatsComponent';
import ClassOverViewPie from '../ClassOverViewPie/ClassOverViewPie';

function TeacherAnalytics() {
  return (
    <div className='teacher-analytics-container'>
      <div className='teacher-analytics-headers'>
      <h3>Analytics OverView</h3>
      <h4>Rated</h4>
      </div>
      <div className='teacher-analytics-row'>
      <div className='teacher-analytics '>
        <div className='teacher-analytics-stats-grid'>  
          <TeacherStatsComponent />
          <TeacherStatsComponent />
        </div>
      
        <div className='teacher-analytics-stats-grid'>  
          <TeacherStatsComponent />
          <TeacherStatsComponent />
        </div>
      </div>
      <ClassOverViewPie />
      </div>
    </div>
  )
}

export default TeacherAnalytics